import React from 'react'
import { Form, Sidebar } from '.'

const ContentField = () => {
  return (
    <div className="flex flex-wrap -mx-4">
      <div className="w-2/3 pl-4 pr-8">
        <Form />
      </div>
      <div className="w-1/3 px-4">
        <Sidebar />
      </div>
    </div>
  )
}

export { ContentField }